import React from 'react'
import Modal from '@material-ui/core/Modal'
import styles from './styles.module.css'
import TextField from '@material-ui/core/TextField'
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import IconButton from '@material-ui/core/IconButton' 
import axios from 'axios'
import Button from '@material-ui/core/Button'
import Divider from '@material-ui/core/Divider'
import Dialog from '@material-ui/core/Dialog';
import {connect} from 'react-redux'; 
import { v4 as uuidv4 } from 'uuid'; 
import SelectSearch from '../../utils/Selectsearch/SelectSearch';

const ConfLocation = (props) => {
    const [formData,setFormData] = React.useState({
        locationId: "",
        name: "",
        uniqueCode: uuidv4(),
        userId: props.user._id,
        godown: ""
    }); 

    const [loading,setLoading] = React.useState(false) 
    React.useEffect(() => {
        if(props.type == "EDIT") { 
            setFormData({...formData,...props.location,locationId: props.location._id})
        } 
    },[props.location]); 
 
    // SUBMIT
    const onSubmit = () => {
        setLoading(true);
        const url = props.type == "EDIT" ? "/editLocation" : "/addLocation"

        axios({
            method: "post",
            url: url,
            data: {
                ...formData, 
                godownId: formData.godown._id
            }
        })
        .then(res => {
            if(res.data.success) {
                setFormData({...formData,locationId: "",name: "",uniqueCode: uuidv4()})
                props.onDone()
                setLoading(false);
                props.setAlert("Succesfully Done")
            } else {
                setLoading(false)
                props.setAlert("Something went wrong Try Again")
            }
        }).catch(err => {
            console.log(err)
            props.setAlert("Something went wrong Try Again")
            setLoading(false)
        })
    }

    let btnText = props.type == "EDIT" ? "Update Location" : "Add Location";
    return (  
        <Dialog open={props.open} onClose={props.onClose} scroll={'paper'} maxWidth={'md'} fullWidth={true}>
            <div className={styles.container}>
                <div className={styles.containerContent}>
                    
                    <div className={styles.header}>
                        <h1>{btnText}</h1>
                        <IconButton onClick={props.onClose}>
                            <CloseRoundedIcon   />
                        </IconButton>
                    </div>

                    <h2>Details</h2>

                    <div className={styles.content}>
                        <div className={styles.row}>
                            <SelectSearch 
                                variant="outlined"
                                className={styles.textField}
                                label="Select Godown"
                                value={formData.godown}
                                onChange={(value) => setFormData({...formData,godown: value})}
                                options={props.goDown}
                                keyCode="name"
                            /> 
                            <TextField 
                                variant="outlined"
                                className={styles.textField}
                                label="Name"
                                value={formData.name}
                                onChange={(e) => setFormData({...formData,name: e.target.value})}
                            />
                        </div>   

                        <div className={styles.row}>
                            <TextField 
                                variant="outlined"
                                className={styles.textField}
                                label="Code"
                                value={formData.uniqueCode}
                                onChange={(e) => setFormData({...formData,uniqueCode: e.target.value})}
                            /> 
                        </div>   
                    </div>

                    <Divider />
 
                     
                    <div className={styles.footer}>
                        {loading 
                            ?
                        <Button variant="contained" color="secondary">
                            Loading....
                        </Button>
                            :
                        <Button variant="contained" color="secondary" onClick={onSubmit}>
                            {btnText}
                        </Button>}
                    </div>
                </div>
            </div>
        </Dialog>  
    )
}

const mapStateToProps = state => ({
    user: state.appReducer.user
})
export default connect(mapStateToProps)(ConfLocation);